import { Grid, makeStyles } from '@material-ui/core'
import Button from '../../../../../control/button/button'
import { Form } from 'react-final-form'
import useLoading from '../../../../../control/loading/useLoading'
import MyTextfield from '../../../../../control/textfield/textfield'
import useTranslate from '../../../../../i18n/useTranslate'
import { SearchForm, SearchResult } from '../../../../../services/manageExternalProject/searchFormExternalProjectType'
import useManageExternalProject from '../../../../../services/manageExternalProject/useManageExternalProject'

const SearchFormExternalProject = (props: SearchResult) => {
    const { setData, keywordSearchRef, currentPageNoRef, allData } = props
    const onSearch = useManageExternalProject()
    const { loadingClose, loadingOpen } = useLoading()

    const translate = useTranslate()

    let keywordSearchPlaceholder: string = `${translate.get('LABEL.PROJECT_NAME')}, ${translate.get(
        'LABEL.RESEARCHER_FL_NAME',
    )}, ${translate.get('LABEL.COA_NO')}`

    const classes = useStyles()

    const handleSubmit = async (values: SearchForm) => {
        try {
            loadingOpen()
            currentPageNoRef.current = 1
            const response = await onSearch.getData(values)
            setData(response.data)
            allData.current = response.total ?? 0
            keywordSearchRef.current = values.keywordSearch ? values.keywordSearch : ''
        } catch (error) {
            console.log(error)
        } finally {
            loadingClose()
        }
    }
    const onEnter = (val: { keywordSearch?: string; pageNo: number; pageSize: number }) => {
        handleSubmit(val)
    }

    return (
        <Form
            onSubmit={handleSubmit}
            render={({ handleSubmit, form, values }) => {
                return (
                    <Grid className={classes.container} container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <MyTextfield
                                name="keywordSearch"
                                materialInputProps={{
                                    disabled: false,
                                    label: translate.get('LABEL.SEARCH_BY_KEYWORD'),
                                    placeholder: keywordSearchPlaceholder,
                                    size: 'small',
                                }}
                                onEnter={() => onEnter(values)}
                            />
                        </Grid>
                        <Grid container justify="flex-end" spacing={2}>
                            <Grid item>
                                <Button
                                    className={classes.btnGroup}
                                    size={'large'}
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        form.reset()
                                        handleSubmit()
                                    }}
                                    color="default"
                                    type="button"
                                >
                                    {translate.get('BUTTON.RESET')}
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    className={classes.btnGroup}
                                    size={'large'}
                                    fullWidth
                                    variant="contained"
                                    onClick={handleSubmit}
                                    color="primary"
                                    type="submit"
                                >
                                    {translate.get('BUTTON.SEARCH')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        />
    )
}

const useStyles = makeStyles((theme) => ({
    container: {
        padding: '15px',
    },
    btnGroup: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))

export default SearchFormExternalProject
